import BaseModel from "../base/baseModel";

import DadosNfeModel from "./dados/dadosNfeModel";
import ProtocoloNfeModel from "./protocolo/protocoloNfeModel";

export default class NotaFiscalEletronicaModel extends BaseModel {
    dados: DadosNfeModel = new DadosNfeModel();
    protNFE: ProtocoloNfeModel = new ProtocoloNfeModel();
}
